export var rankPercent = function (r, t) { return (1 - r / t) * 100; };
